var _excluded = ["analyticsName", "headingStyle", "asProp", "ref"],
    _excluded2 = ["as", "analyticsName"];

function cov_nvx2l5u8j() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx";
  var hash = "b95a47fd0cfe25739bf49ff3e38b1d1708bc5155";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Heading/Heading.tsx",
    statementMap: {
      "0": {
        start: {
          line: 35,
          column: 4
        },
        end: {
          line: 56,
          column: 1
        }
      },
      "1": {
        start: {
          line: 36,
          column: 29
        },
        end: {
          line: 36,
          column: 51
        }
      },
      "2": {
        start: {
          line: 37,
          column: 30
        },
        end: {
          line: 40,
          column: 4
        }
      },
      "3": {
        start: {
          line: 41,
          column: 2
        },
        end: {
          line: 46,
          column: 30
        }
      },
      "4": {
        start: {
          line: 42,
          column: 4
        },
        end: {
          line: 44,
          column: 5
        }
      },
      "5": {
        start: {
          line: 43,
          column: 6
        },
        end: {
          line: 43,
          column: 86
        }
      },
      "6": {
        start: {
          line: 47,
          column: 27
        },
        end: {
          line: 47,
          column: 41
        }
      },
      "7": {
        start: {
          line: 48,
          column: 2
        },
        end: {
          line: 55,
          column: 4
        }
      },
      "8": {
        start: {
          line: 58,
          column: 47
        },
        end: {
          line: 84,
          column: 1
        }
      },
      "9": {
        start: {
          line: 60,
          column: 17
        },
        end: {
          line: 60,
          column: 57
        }
      },
      "10": {
        start: {
          line: 61,
          column: 19
        },
        end: {
          line: 61,
          column: 66
        }
      },
      "11": {
        start: {
          line: 62,
          column: 18
        },
        end: {
          line: 62,
          column: 75
        }
      },
      "12": {
        start: {
          line: 63,
          column: 4
        },
        end: {
          line: 73,
          column: 5
        }
      },
      "13": {
        start: {
          line: 64,
          column: 6
        },
        end: {
          line: 72,
          column: 8
        }
      },
      "14": {
        start: {
          line: 74,
          column: 29
        },
        end: {
          line: 74,
          column: 43
        }
      },
      "15": {
        start: {
          line: 75,
          column: 4
        },
        end: {
          line: 82,
          column: 6
        }
      },
      "16": {
        start: {
          line: 92,
          column: 51
        },
        end: {
          line: 92,
          column: 94
        }
      },
      "17": {
        start: {
          line: 92,
          column: 62
        },
        end: {
          line: 92,
          column: 94
        }
      },
      "18": {
        start: {
          line: 93,
          column: 51
        },
        end: {
          line: 93,
          column: 94
        }
      },
      "19": {
        start: {
          line: 93,
          column: 62
        },
        end: {
          line: 93,
          column: 94
        }
      },
      "20": {
        start: {
          line: 94,
          column: 51
        },
        end: {
          line: 94,
          column: 94
        }
      },
      "21": {
        start: {
          line: 94,
          column: 62
        },
        end: {
          line: 94,
          column: 94
        }
      },
      "22": {
        start: {
          line: 95,
          column: 51
        },
        end: {
          line: 95,
          column: 94
        }
      },
      "23": {
        start: {
          line: 95,
          column: 62
        },
        end: {
          line: 95,
          column: 94
        }
      },
      "24": {
        start: {
          line: 96,
          column: 51
        },
        end: {
          line: 96,
          column: 94
        }
      },
      "25": {
        start: {
          line: 96,
          column: 62
        },
        end: {
          line: 96,
          column: 94
        }
      },
      "26": {
        start: {
          line: 97,
          column: 51
        },
        end: {
          line: 97,
          column: 94
        }
      },
      "27": {
        start: {
          line: 97,
          column: 62
        },
        end: {
          line: 97,
          column: 94
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 35,
            column: 4
          },
          end: {
            line: 35,
            column: 5
          }
        },
        loc: {
          start: {
            line: 35,
            column: 64
          },
          end: {
            line: 56,
            column: 1
          }
        },
        line: 35
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 41,
            column: 18
          },
          end: {
            line: 41,
            column: 19
          }
        },
        loc: {
          start: {
            line: 41,
            column: 24
          },
          end: {
            line: 46,
            column: 3
          }
        },
        line: 41
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 59,
            column: 2
          },
          end: {
            line: 59,
            column: 3
          }
        },
        loc: {
          start: {
            line: 59,
            column: 44
          },
          end: {
            line: 83,
            column: 3
          }
        },
        line: 59
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 92,
            column: 51
          },
          end: {
            line: 92,
            column: 52
          }
        },
        loc: {
          start: {
            line: 92,
            column: 62
          },
          end: {
            line: 92,
            column: 94
          }
        },
        line: 92
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 93,
            column: 51
          },
          end: {
            line: 93,
            column: 52
          }
        },
        loc: {
          start: {
            line: 93,
            column: 62
          },
          end: {
            line: 93,
            column: 94
          }
        },
        line: 93
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 94,
            column: 51
          },
          end: {
            line: 94,
            column: 52
          }
        },
        loc: {
          start: {
            line: 94,
            column: 62
          },
          end: {
            line: 94,
            column: 94
          }
        },
        line: 94
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 95,
            column: 51
          },
          end: {
            line: 95,
            column: 52
          }
        },
        loc: {
          start: {
            line: 95,
            column: 62
          },
          end: {
            line: 95,
            column: 94
          }
        },
        line: 95
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 96,
            column: 51
          },
          end: {
            line: 96,
            column: 52
          }
        },
        loc: {
          start: {
            line: 96,
            column: 62
          },
          end: {
            line: 96,
            column: 94
          }
        },
        line: 96
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 97,
            column: 51
          },
          end: {
            line: 97,
            column: 52
          }
        },
        loc: {
          start: {
            line: 97,
            column: 62
          },
          end: {
            line: 97,
            column: 94
          }
        },
        line: 97
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 42,
            column: 4
          },
          end: {
            line: 44,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 42
      },
      "1": {
        loc: {
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 42,
            column: 31
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 42,
            column: 8
          },
          end: {
            line: 42,
            column: 14
          }
        }, {
          start: {
            line: 42,
            column: 18
          },
          end: {
            line: 42,
            column: 31
          }
        }],
        line: 42
      },
      "2": {
        loc: {
          start: {
            line: 60,
            column: 17
          },
          end: {
            line: 60,
            column: 57
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 60,
            column: 35
          },
          end: {
            line: 60,
            column: 45
          }
        }, {
          start: {
            line: 60,
            column: 48
          },
          end: {
            line: 60,
            column: 57
          }
        }],
        line: 60
      },
      "3": {
        loc: {
          start: {
            line: 61,
            column: 20
          },
          end: {
            line: 61,
            column: 43
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 61,
            column: 20
          },
          end: {
            line: 61,
            column: 22
          }
        }, {
          start: {
            line: 61,
            column: 27
          },
          end: {
            line: 61,
            column: 42
          }
        }],
        line: 61
      },
      "4": {
        loc: {
          start: {
            line: 62,
            column: 52
          },
          end: {
            line: 62,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 62,
            column: 52
          },
          end: {
            line: 62,
            column: 56
          }
        }, {
          start: {
            line: 62,
            column: 60
          },
          end: {
            line: 62,
            column: 62
          }
        }],
        line: 62
      },
      "5": {
        loc: {
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 63,
            column: 4
          },
          end: {
            line: 73,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 63
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "b95a47fd0cfe25739bf49ff3e38b1d1708bc5155"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_nvx2l5u8j = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_nvx2l5u8j();

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { useStyleConfig } from '../../system/utils';
import { bricks } from '../../system/bricks.types';
import { forwardRef } from '@chakra-ui/system';
import { useInView } from 'react-intersection-observer';
import { useObservabilitySafe } from '../../hooks/useObservabilitySafe';
import { useMergeRefs } from '@chakra-ui/hooks';
cov_nvx2l5u8j().s[0]++;

var HeadingWithTracking = function HeadingWithTracking(_ref) {
  var analyticsName = _ref.analyticsName,
      headingStyle = _ref.headingStyle,
      asProp = _ref.asProp,
      ref = _ref.ref,
      props = _objectWithoutProperties(_ref, _excluded);

  cov_nvx2l5u8j().f[0]++;

  var _ref2 = (cov_nvx2l5u8j().s[1]++, useObservabilitySafe()),
      trackUserEvent = _ref2.trackUserEvent;

  var _ref3 = (cov_nvx2l5u8j().s[2]++, useInView({
    threshold: 1,
    skip: !analyticsName
  })),
      _ref4 = _slicedToArray(_ref3, 2),
      inViewRef = _ref4[0],
      inView = _ref4[1];

  cov_nvx2l5u8j().s[3]++;
  React.useEffect(function () {
    cov_nvx2l5u8j().f[1]++;
    cov_nvx2l5u8j().s[4]++;

    if ((cov_nvx2l5u8j().b[1][0]++, inView) && (cov_nvx2l5u8j().b[1][1]++, analyticsName)) {
      cov_nvx2l5u8j().b[0][0]++;
      cov_nvx2l5u8j().s[5]++;
      trackUserEvent({
        textViewEvent: {
          targetName: "".concat(analyticsName, "-").concat(asProp)
        }
      });
    } else {
      cov_nvx2l5u8j().b[0][1]++;
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [inView, analyticsName]);
  var HeadingComponent = (cov_nvx2l5u8j().s[6]++, bricks(asProp));
  cov_nvx2l5u8j().s[7]++;
  return /*#__PURE__*/React.createElement(HeadingComponent // __css has a lower priority than sx
  , _extends({
    __css: headingStyle,
    ref: useMergeRefs(inViewRef, ref)
  }, props));
};

export var Heading = (cov_nvx2l5u8j().s[8]++, forwardRef(function (_ref5, ref) {
  var _ref6, _ref7;

  var as = _ref5.as,
      analyticsName = _ref5.analyticsName,
      props = _objectWithoutProperties(_ref5, _excluded2);

  cov_nvx2l5u8j().f[2]++;
  var size = (cov_nvx2l5u8j().s[9]++, 'size' in props ? (cov_nvx2l5u8j().b[2][0]++, props.size) : (cov_nvx2l5u8j().b[2][1]++, undefined));
  var asProp = (cov_nvx2l5u8j().s[10]++, (_ref6 = (cov_nvx2l5u8j().b[3][0]++, as)) !== null && _ref6 !== void 0 ? _ref6 : (cov_nvx2l5u8j().b[3][1]++, size));
  var style = (cov_nvx2l5u8j().s[11]++, useStyleConfig('Heading', _objectSpread({
    size: (_ref7 = (cov_nvx2l5u8j().b[4][0]++, size)) !== null && _ref7 !== void 0 ? _ref7 : (cov_nvx2l5u8j().b[4][1]++, as)
  }, props)));
  cov_nvx2l5u8j().s[12]++;

  if (analyticsName) {
    cov_nvx2l5u8j().b[5][0]++;
    cov_nvx2l5u8j().s[13]++;
    return /*#__PURE__*/React.createElement(HeadingWithTracking, _extends({
      asProp: asProp,
      ref: ref,
      headingStyle: style,
      analyticsName: analyticsName
    }, props));
  } else {
    cov_nvx2l5u8j().b[5][1]++;
  }

  var HeadingComponent = (cov_nvx2l5u8j().s[14]++, bricks(asProp));
  cov_nvx2l5u8j().s[15]++;
  return /*#__PURE__*/React.createElement(HeadingComponent // __css has a lower priority than sx
  , _extends({
    __css: style,
    ref: ref
  }, props));
})); ////////////////////////////////////////////////////////////////////////////////
// Shorthand aliases for the different heading levels.
////////////////////////////////////////////////////////////////////////////////

cov_nvx2l5u8j().s[16]++;
export var H1 = function H1(props) {
  cov_nvx2l5u8j().f[3]++;
  cov_nvx2l5u8j().s[17]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h1"
  }, props));
};
cov_nvx2l5u8j().s[18]++;
export var H2 = function H2(props) {
  cov_nvx2l5u8j().f[4]++;
  cov_nvx2l5u8j().s[19]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h2"
  }, props));
};
cov_nvx2l5u8j().s[20]++;
export var H3 = function H3(props) {
  cov_nvx2l5u8j().f[5]++;
  cov_nvx2l5u8j().s[21]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h3"
  }, props));
};
cov_nvx2l5u8j().s[22]++;
export var H4 = function H4(props) {
  cov_nvx2l5u8j().f[6]++;
  cov_nvx2l5u8j().s[23]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h4"
  }, props));
};
cov_nvx2l5u8j().s[24]++;
export var H5 = function H5(props) {
  cov_nvx2l5u8j().f[7]++;
  cov_nvx2l5u8j().s[25]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h5"
  }, props));
};
cov_nvx2l5u8j().s[26]++;
export var H6 = function H6(props) {
  cov_nvx2l5u8j().f[8]++;
  cov_nvx2l5u8j().s[27]++;
  return /*#__PURE__*/React.createElement(Heading, _extends({
    size: "h6"
  }, props));
};
export default Heading;